/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetGenerateRequest
 */
export interface ResetGenerateRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetGenerateRequest
     */
    email?: string;
}

export function ResetGenerateRequestFromJSON(json: any): ResetGenerateRequest {
    return ResetGenerateRequestFromJSONTyped(json, false);
}

export function ResetGenerateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetGenerateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function ResetGenerateRequestToJSON(value?: ResetGenerateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}


